import React, { useState } from 'react';
import { Snowflake, Eye, Key, EyeOff, Wifi } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
export function CardScreen() {
  const [isFrozen, setIsFrozen] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-95">
      <header className="bg-[#003366] px-6 pt-12 pb-6 sticky top-0 z-10" data-id="element-96">
        <h1 className="text-2xl font-bold text-white" data-id="element-97">Ma Carte</h1>
      </header>

      <div className="px-6 py-8 space-y-8 -mt-2" data-id="element-98">
        {/* Visa Card Visual */}
        <div className="relative w-full aspect-[1.586] rounded-2xl overflow-hidden shadow-2xl transform transition-transform hover:scale-[1.02] duration-300" data-id="element-99">
          {/* Background Gradient - First Bank colors */}
          <div className={`absolute inset-0 bg-gradient-to-br from-[#003366] via-[#004080] to-[#D4A017] ${isFrozen ? 'grayscale opacity-90' : ''}`} data-id="element-100" />

          {/* Noise Texture Overlay */}
          <div className="absolute inset-0 opacity-10 bg-[url('https://grainy-gradients.vercel.app/noise.svg')]" data-id="element-101"></div>

          {/* Card Content */}
          <div className="relative h-full p-6 flex flex-col justify-between text-white" data-id="element-102">
            <div className="flex justify-between items-start" data-id="element-103">
              <div data-id="element-104">
                <span className="font-bold tracking-wider text-sm opacity-90" data-id="element-105">
                  ALAL x FBN
                </span>
                <div className="text-[10px] opacity-70 mt-0.5" data-id="element-106">
                  Édition Voyage
                </div>
              </div>
              <Wifi className="rotate-90 opacity-80" size={24} data-id="element-107" />
            </div>

            <div className="flex items-center gap-3 my-auto" data-id="element-108">
              <div className="w-10 h-8 bg-yellow-100 rounded-md bg-gradient-to-br from-yellow-200 to-yellow-500 shadow-sm border border-yellow-600/20 flex items-center justify-center" data-id="element-109">
                <div className="w-full h-[1px] bg-black/20 my-[2px]" data-id="element-110"></div>
              </div>
              <Wifi className="rotate-90 opacity-0 w-6" data-id="element-111" />
            </div>

            <div data-id="element-112">
              <div className="font-mono text-xl tracking-widest mb-4 flex items-center gap-2" data-id="element-113">
                <span data-id="element-114">••••</span>
                <span data-id="element-115">••••</span>
                <span data-id="element-116">••••</span>
                <span data-id="element-117">{showDetails ? '4829' : '4829'}</span>
              </div>

              <div className="flex justify-between items-end" data-id="element-118">
                <div data-id="element-119">
                  <div className="text-[10px] opacity-70 uppercase tracking-wider mb-0.5" data-id="element-120">
                    Titulaire
                  </div>
                  <div className="font-medium tracking-wide" data-id="element-121">AMADOU DIALLO</div>
                </div>
                <div className="flex flex-col items-end" data-id="element-122">
                  <span className="text-[10px] opacity-70 mb-1" data-id="element-123">VISA</span>
                  <div className="font-bold italic text-2xl leading-none" data-id="element-124">
                    VISA
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Frozen Overlay */}
          {isFrozen && <div className="absolute inset-0 flex items-center justify-center bg-black/20 backdrop-blur-[2px]" data-id="element-125">
              <div className="bg-white/20 backdrop-blur-md px-4 py-2 rounded-full flex items-center gap-2 border border-white/30" data-id="element-126">
                <Snowflake size={16} className="text-white" data-id="element-127" />
                <span className="text-white font-medium text-sm" data-id="element-128">
                  Carte gelée
                </span>
              </div>
            </div>}
        </div>

        {/* Status Pill */}
        <div className="flex justify-center" data-id="element-129">
          <div className={`px-4 py-1.5 rounded-full text-sm font-medium flex items-center gap-2 ${isFrozen ? 'bg-blue-50 text-blue-700' : 'bg-green-50 text-green-700'}`} data-id="element-130">
            <div className={`w-2 h-2 rounded-full ${isFrozen ? 'bg-blue-500' : 'bg-green-500'}`} data-id="element-131"></div>
            {isFrozen ? 'Gelée' : 'Active'}
          </div>
        </div>

        {/* Actions */}
        <div className="space-y-3" data-id="element-132">
          <Button variant="outline" fullWidth className="justify-between h-14 bg-white border-gray-100 shadow-sm hover:bg-gray-50" onClick={() => setIsFrozen(!isFrozen)} data-id="element-133">
            <div className="flex items-center gap-3" data-id="element-134">
              <div className="p-2 bg-blue-50 text-blue-600 rounded-lg" data-id="element-135">
                <Snowflake size={20} data-id="element-136" />
              </div>
              <span className="font-medium text-gray-900" data-id="element-137">
                {isFrozen ? 'Dégeler la carte' : 'Geler la carte'}
              </span>
            </div>
          </Button>

          <Button variant="outline" fullWidth className="justify-between h-14 bg-white border-gray-100 shadow-sm hover:bg-gray-50" onClick={() => setShowDetails(!showDetails)} data-id="element-138">
            <div className="flex items-center gap-3" data-id="element-139">
              <div className="p-2 bg-purple-50 text-purple-600 rounded-lg" data-id="element-140">
                {showDetails ? <EyeOff size={20} data-id="element-141" /> : <Eye size={20} data-id="element-142" />}
              </div>
              <span className="font-medium text-gray-900" data-id="element-143">
                {showDetails ? 'Masquer les détails' : 'Voir les détails'}
              </span>
            </div>
          </Button>

          <Button variant="outline" fullWidth className="justify-between h-14 bg-white border-gray-100 shadow-sm hover:bg-gray-50" data-id="element-144">
            <div className="flex items-center gap-3" data-id="element-145">
              <div className="p-2 bg-orange-50 text-orange-600 rounded-lg" data-id="element-146">
                <Key size={20} data-id="element-147" />
              </div>
              <span className="font-medium text-gray-900" data-id="element-148">
                Réinitialiser le PIN
              </span>
            </div>
          </Button>
        </div>

        {/* Security Note */}
        <div className="bg-[#003366]/5 p-4 rounded-xl flex gap-3 items-start border border-[#003366]/10" data-id="element-149">
          <div className="mt-0.5 text-[#003366]" data-id="element-150">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-151">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-152" />
            </svg>
          </div>
          <div data-id="element-153">
            <h4 className="text-sm font-semibold text-[#003366]" data-id="element-154">
              Sécurité bancaire
            </h4>
            <p className="text-xs text-[#003366]/70 mt-1" data-id="element-155">
              Votre carte est protégée par 3D Secure pour les paiements en
              ligne. Ne partagez jamais votre PIN ou OTP.
            </p>
          </div>
        </div>
      </div>
    </div>;
}